import { Component } from '@angular/core';
import {IonicPage, NavController, ModalController, AlertController, ViewController, App } from 'ionic-angular';

import { Items } from '../../providers/providers';
import { User } from '../../providers/user';
import { Item } from '../../models/item';
import { News } from '../../models/news';
import { Alerts } from '../../models/alerts';
import { UserData } from '../../models/user';
import { Assessment } from '../../models/assessment';

@IonicPage({
  name: 'redirect-insights',
  segment: 'redirect-insights',
  //priority: 'high'
})
@Component({
  selector: 'redirect-insights-page',
  templateUrl: 'redirect-insights.html'
})
export class RedirectInsightsPage {
  userData: UserData;
  group: any = '';
  user_type: any = '0';
  

  constructor(public navCtrl: NavController, public items: Items, public modalCtrl: ModalController,
    public alertCtrl: AlertController,
    public viewCtrl: ViewController, public user: User,
    //private navParams: NavParams,
    public app: App) {
      //this.addToken()
  }
  
  /**
   * The view loaded, let's query our news and recentActivities for the list
   */
  ionViewDidLoad() {
    this.userData = <UserData>JSON.parse(localStorage.getItem('userData'));
    console.log(this.userData);
    if(this.userData){
      this.user_type = this.userData.usertype_id;
      this.getGroupings();
    } else {
      this.loggedOut();
    }
  }
  

  getGroupings() {
    this.items.getGroupings().subscribe(res => {
      if (res) {
        if (res.length > 0) {
          this.group = res[0].Grouping.name;
        }
        this.addToken();
      }
    },
    err => {
      console.log(err);
    });
  }

  addToken() {
    if (this.group || this.user_type != '3') {
      this.items.addToken().subscribe(res => {
        console.log(res.result);
        // const d = new Date();
        // d.setTime(d.getTime() + (24 * 60 * 60 * 1000));
        // let expires = "expires="+d.toUTCString();
        // document.cookie = 'token' + "=" + res.result + ";" + expires + ";path=/";
        // document.cookie = 'shiny-token' + "=" + res.result + ";" + expires + ";path=/";
        // document.cookie = 'shiny-user-level' + "=" + this.user_type + ";" + expires + ";path=/";
        // document.cookie = 'shiny-user-group' + "=" + this.group + ";" + expires + ";path=/";
        window.location.href = 'https://growingminds.novopsych.com/insights/?token=' + res.result;
      },
        err => {
          console.log(err);
          this.loggedOut();
      });
    } else {
      let prompt = this.alertCtrl.create({
        // title: 'Enter Password',
        message: "Insufficient permisision to access Insight Page. Please contact your account manager.",
        buttons: [
          {
            text: 'Ok',
            handler: data => {
              this.navCtrl.push('home');
            }
          }
        ]
      });
      prompt.present();
    }
  }

  loggedOut() {
    let prompt = this.alertCtrl.create({
      // title: 'Enter Password',
      message: "You are logged out, please login again.",
      buttons: [
        {
          text: 'Ok',
          handler: data => {
            localStorage.clear();
            this.navCtrl.push('login');
          }
        }
      ]
    });
    prompt.present();
  }

  backToWelcome(){
     const root = this.app.getRootNav();
     root.popToRoot();
  }

  
}



// WEBPACK FOOTER //
// ./src/pages/redirect-insights/redirect-insights.ts